"use strict";
// packages/types/src/pageSnapshot.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStatus = void 0;
var PageStatus;
(function (PageStatus) {
    PageStatus["NEW"] = "new";
    PageStatus["UPDATED"] = "updated";
    PageStatus["UNCHANGED"] = "unchanged";
})(PageStatus || (exports.PageStatus = PageStatus = {}));
